<template>
    <div id="notePadReviewReport">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Velocity Non Billable Units </div>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'nonBillableUnits'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                              <custom-pagination
                                  :page-changed="onPageChange"
                                  :per-page-changed="onPerPageChange" :moduleName="'nonBillableUnits'" :position="'top'">
                              </custom-pagination>
                              <vue-good-table
                                  ref="NonBillableUnits"
                                  mode="remote"
                                  title="Non Billable Unit"
                                  @on-page-change="onPageChange"
                                  @on-column-filter="onColumnFilter"
                                  @on-per-page-change="onPerPageChange"
                                  @on-sort-change="onSortChange"
                                  @on-select-all="onSelectAll"
                                  @on-selected-rows-change="selectionChanged"
                                  :totalRows="totalRecords"
                                  :columns="userColumns"
                                  :rows="rows"
                                  :pagination-options="{
                                      enabled: false,
                                      position: 'both',
                                      perPage: perPage,
                                      perPageDropdown:dropDownPerPage,
                                      dropdownAllowAll: false,
                                  }"
                                  :select-options="{
                                      enabled: false,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                  }"
                                  :search-options="{
                                      enabled: false,
                                  }">
                                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                      <div :key="key">
                                          <!-- <div v-if="props.column.field == 'note_comments'">
                                              <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                          </div>
                                          <div v-else> -->
                                              {{props.formattedRow[props.column.field]}}
                                          <!-- </div> -->
                                      </div>
                                  </template>
                              </vue-good-table>
                              <custom-pagination
                                  :page-changed="onPageChange"
                                  :per-page-changed="onPerPageChange">
                              </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./../event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
    name: "NotePadReviewReport",
    metaInfo() {
        return {
            title: "Non Billable Unit | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label: 'Unit Number',
                field: 'unit_no',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Unit Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Date In Service',
                field: 'date_in_service',
                fpFieldType:"custom_date",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Date In Service", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'DebtNote',
                field: 'debt_note',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Entity", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Y','N'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
             {
                label: 'Depreciation',
                field: 'depreciation',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Entity", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Y','N'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
             {
                label: 'Contract',
                field: 'contract_bool',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Entity", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Y','N'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'WOCount',
                field: 'wo_count',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Wo Count", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list',
        batchProcess:0,
        batchNum:"",
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'non_billable_unit_report') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {

    },
    mounted: function() {
        var self = this;

        self.getPermissions();
    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.NotePadReview.unselectAllInternal();
        },
        loadList: function() {
            var self = this;

            var selectedRows = [];
            var data = this.$refs['NonBillableUnits'].selectedRows;
            for ( var i = 0; i < data.length; i++ ) {
                selectedRows.push(this.$refs['NonBillableUnits'].selectedRows[i].id)
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action: self.action,
                selectedAll:self.serverParams.selectedAll,
                selectedRows:selectedRows,
            };

            self.firstLoad = 1;
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/non-billable-unit-report/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          self.loadList();
                        } else {
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'non-billable-unit')
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/NonBillableUnitReport.vue